import auth from 'app/auth';
import { SessionAction, SessionActionTypes } from 'app/dux/session/actionTypes';
import { Reducer } from 'redux';
import { SessionState, AuthState } from './types';

const initialState: SessionState = {
    accessTokenPayload: undefined,
    authState: (auth as any).state as AuthState,
    locale: undefined,
    delegateCompanyId: undefined,
};

export const sessionReducer: Reducer<SessionState, SessionAction> = (
    state: SessionState = initialState,
    action: SessionAction
): SessionState => {
    switch (action.type) {
        case SessionActionTypes.SET_USER_DATA:
            return {
                ...state,
                authState: action.authState,
                accessTokenPayload: action.accessTokenPayload,
                delegateCompanyId: action.delegateCompanyId,
            };
    }

    return state;
};
